import { render } from "./BoxAndBarWithValue.vue?vue&type=template&id=79493f4c"
import script from "./BoxAndBarWithValue.vue?vue&type=script&lang=js"
export * from "./BoxAndBarWithValue.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__